var e,
    t = require("react"),
    r = (e = require("fuse.js")) && "object" == typeof e && "default" in e ? e.default : e;

module.exports = function (e) {
  var a = e.data,
      u = e.options,
      s = t.useState(""),
      n = s[0],
      o = s[1],
      f = Object.assign({}, {
    threshold: .2
  }, u);
  return {
    result: function (e) {
      var t = e.data,
          r = e.term,
          a = e.fuse.search("" + r);
      return r ? a : t;
    }({
      data: a,
      term: n,
      fuse: new r(a, f)
    }),
    search: o,
    term: n,
    reset: function reset() {
      return o("");
    }
  };
};